exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".swiper-container{overflow:visible}.swiper-slide img{max-width:100%;vertical-align:middle;display:table-cell;margin:0 auto}@media screen and (max-width:768px){.swiper-slide img{position:relative;max-width:100%;max-height:298px}}.swiper-container .swiper-slide{line-height:300px;display:table}.max-height{height:100%}.open-images-modal{cursor:pointer}.swiper-pagination-bullet-active{background:#ed1763}.swiper-pagination{margin-top:10px;position:unset}.swiper-pagination-bullet{width:10px;height:10px}.swiper-pagination-bullet-custom:hover{border:2px solid #000;background:#ed1763;opacity:1}.swiper-slide:not([class*=active]){opacity:0!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-74f3ec35","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/store/components/TemplateCarousel.vue
// module id = Yw32
// module chunks = 102